import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import GifService from "@services/GifService";
import Gif from "@ltypes/gif";
import Loader from "@components/ui/Loader/Loader";
import TextField from "../TextField/TextField";
import "./GifSelector.scss";

type GifSelectorProps = {
    className?: string,
    label?: string,
    value: number,
    onChange: (gifId: number) => void,
};

function GifSelector(props: GifSelectorProps) {
    const [isLoading, setLoading] = useState<boolean>(true);
    const [gifs, setGifs] = useState<Array<Gif>>([]);
    const [searchTerm, setSearchTerm] = useState<string>('');

    const timerRef = useRef<any>(null);

    const service = new GifService;

    const { t } = useTranslation();

    const search = (term: string): void => {
        setLoading(true);
        const promise = service.get(term);
        
        promise.then((data: any) => {
            setGifs(data.body);
        }).finally(() => {
            setLoading(false);
        });
    };

    useEffect(() => {
        search('');
    }, []);

    useEffect(() => {
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            search(searchTerm);
        }, 300);
    }, [searchTerm]);

    return (
        <div className={`gif-selector ${props.className ?? ''}`}>
            <div className="row mt-1 g-3">
                <div className="col-12">
                    {props.label && (
                        <span className="gif-selector-label">{props.label}</span>
                    )}
                    <TextField value={searchTerm} placeholder={t('page.scenes.data.search_gif_placeholder')} onChange={setSearchTerm}/>
                </div>
                <div className="col-12">
                    {isLoading ? (
                        <Loader size="2.5rem" noMargin/>
                    ) : (
                        <div className="gif-selector-gifs">
                            {gifs.map((gif: Gif) => (
                                <div key={gif.id} className={`gif-selector-gifs-item ${props.value === gif.id ? 'active' : ''}`} onClick={() => props.onChange(gif.id)} style={{ backgroundImage: `url('${process.env.REACT_APP_API_URL}/media/gifs/${gif.id}.gif')` }}></div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default GifSelector;
